import React from 'react';

const css = `
    .installer-cls-1 {
        stroke-linecap: round;
    }

    .installer-cls-1, .installer-cls-2 {
        fill: none;
        stroke: #003b63;
        stroke-linejoin: round;
    }
`

const InstallerIcon = () => {
    return(
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.833 20.919">
        <style>{css}</style>
        <rect className="installer-cls-1" x="12.497" y="5.17" width="2.196" height="16.929" transform="translate(-5.658 13.52) rotate(-44.742)"/>
        <rect className="installer-cls-1" x=".754" y="2.623" width="9.621" height="5.857" rx="1" ry="1" transform="translate(-2.296 5.525) rotate(-44.742)"/>
        <path className="installer-cls-2" d="M13.521,10.463l1.872-1.889c1.068.445,2.344.239,3.218-.627.897-.889,1.105-2.211.62-3.3l-1.231,1.219-1.525.039.094-1.437,1.276-1.265c-1.101-.547-2.472-.365-3.394.548-.892.884-1.095,2.194-.62,3.28l-1.762,1.778"/>
        <path className="installer-cls-2" d="M8.855,12.056l-1.924,1.942c-1.056-.415-2.303-.203-3.161.647-.897.889-1.105,2.211-.62,3.3l1.231-1.219,1.525-.039-.094,1.437-1.276,1.265c1.101.547,2.472.365,3.394-.548.907-.898,1.099-2.235.594-3.331l1.824-1.84"/>
        </svg>
    )
}

export default InstallerIcon;